import script from "./EllipsisText.vue?vue&type=script&lang=ts&setup=true"
export * from "./EllipsisText.vue?vue&type=script&lang=ts&setup=true"

import "./EllipsisText.vue?vue&type=style&index=0&id=5f0c2afa&lang=less&scoped=true"
script.__scopeId = "data-v-5f0c2afa"

export default script